// Texto de mensagem do chat com "Ler mais" (estilo WhatsApp)
// Limita a 7 linhas; se exceder, mostra botão para expandir/recolher.
import React, { useRef, useState, useLayoutEffect } from 'react';
import { Clamped, ReadMoreButton } from './styled';

const MAX_LINES = 7;

/**
 * @param {{ sender: string, html: string, isUser: boolean }} props
 */
const ChatMessageText = ({ sender, html, isUser }) => {
    const ref = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const [overflowing, setOverflowing] = useState(false);

    useLayoutEffect(() => {
        const el = ref.current;
        if (el) {
            // Detecta se o conteúdo ultrapassa o limite de linhas (quando recolhido)
            setOverflowing(el.scrollHeight > el.clientHeight + 2);
        }
    }, [html]);

    return (
        <>
            <Clamped
                ref={ref}
                expanded={expanded}
                maxLines={MAX_LINES}
                isUser={isUser}
            >
                <strong className="sender">{sender}:</strong>{' '}
                <span dangerouslySetInnerHTML={{ __html: html }} />
            </Clamped>
            {overflowing && (
                <ReadMoreButton onClick={() => setExpanded((e) => !e)}>
                    {expanded ? 'Ler menos' : 'Ler mais'}
                </ReadMoreButton>
            )}
        </>
    );
};

export default ChatMessageText;
